
export const fontsObject: {[key: string]: string[]} = {
  Homestead: [],
  Helvetica: ["Oblique", "BoldOblique", "Light", "Bold", "LightOblique"],
  TimesNewRomanPSMT: [],
  ArialMT: [],
  Arial: ["BoldItalicMT", "BoldMT", "ItalicMT"],
  Courier: ["Bold", "Oblique", "BoldOblique"],
  CourierNewPS: ["BoldItalicMT", "BoldMT", "ItalicMT"],
  CourierNewPSMT: [],
  Futura: ["Medium", "CondensedExtraBold", "CondensedMedium", "MediumItalic"],
  Papyrus: ["Condensed"],
  GillSans: ["Bold", "Light", "Italic"],
  Georgia: ["Bold", "BoldItalic", "Italic"],
  Sullivan: ["Regular", "Bevel", "Fill"],
  Lavanderia: ["Delicate", "Sturdy", "Regular"],
  DemingEP: [],
  OstrichSans: ["Light", "Medium", "Bold", "Black"],
  HelveticaNeue: [
    "UltraLightItalic",
    "LightItalic",
    "CondensedBold",
    "CondensedBlack",
    "Bold",
    "Medium",
    "BoldItalic",
    "UltraLight",
    "Light",
    "Italic"
  ],
  Museo: ["300", "500", "700"],
  MuseoSans: ["300", "700"],
  "Lobster1.4": [],
  LeagueGothic: ["Regular", "CondensedRegular"],
  Audiowide: ["Regular"],
  JosefinSans: ["Bold", "BoldItalic", "LightItalic", "SemiBold", "Thin"],
  Cookie: ["Regular"],
  IndieFlower: [],
  Candal: [],
  OpenSans: ["Bold", "BoldItalic", "Light", "Italic"],
  Roboto: [
    "Regular",
    "Black",
    "Light",
    "BoldItalic",
    "LightItalic",
    "Thin",
    "MediumItalic",
    "Medium",
    "Bold",
    "BlackItalic",
    "ThinItalic"
  ],
  Montserrat: ["Regular", "Bold"],
  Lora: ["Italic", "Regular", "BoldItalic", "Bold", "Italic", "Italic"],
  Lato: [
    "Regular",
    "Hairline",
    "HairlineItalic",
    "LightItalic",
    "Italic",
    "Bold",
    "BoldItalic",
    "Light"
  ],
  PoiretOne: ["Regular"]
};

export const fontList = [
  "Homestead",
  "Helvetica",
  "Helvetica-Oblique",
  "TimesNewRomanPSMT",
  "ArialMT",
  "Arial-BoldItalicMT",
  "Arial-BoldMT",
  "Arial-ItalicMT",
  "Courier",
  "CourierNewPS-BoldItalicMT",
  "CourierNewPS-BoldMT",
  "CourierNewPS-ItalicMT",
  "CourierNewPSMT",
  "Courier-Bold",
  "Courier-Oblique",
  "Courier-BoldOblique",
  "Futura-Medium",
  "Futura-CondensedExtraBold",
  "Futura-CondensedMedium",
  "Futura-MediumItalic",
  "Papyrus",
  "Papyrus-Condensed",
  "GillSans",
  "GillSans-Bold",
  "GillSans-Light",
  "GillSans-Italic",
  "Georgia",
  "Georgia-Bold",
  "Georgia-BoldItalic",
  "Georgia-Italic",
  "Sullivan-Regular",
  "Sullivan-Bevel",
  "Sullivan-Fill",
  "Lavanderia-Delicate",
  "Lavanderia-Sturdy",
  "Lavanderia-Regular",
  "DemingEP",
  "OstrichSans-Light",
  "OstrichSans-Medium",
  "OstrichSans-Bold",
  "OstrichSans-Black",
  "HelveticaNeue-UltraLightItalic",
  "HelveticaNeue-LightItalic",
  "HelveticaNeue-CondensedBold",
  "HelveticaNeue-CondensedBlack",
  "HelveticaNeue-Bold",
  "HelveticaNeue-Medium",
  "HelveticaNeue-BoldItalic",
  "HelveticaNeue-UltraLight",
  "HelveticaNeue-Light",
  "HelveticaNeue-Italic",
  "HelveticaNeue",
  "Helvetica-BoldOblique",
  "Helvetica-Light",
  "Helvetica-Bold",
  "Helvetica-LightOblique",
  "Museo-300",
  "Museo-500",
  "Museo-700",
  "MuseoSans-300",
  "MuseoSans-700",
  "Lobster1.4",
  "LeagueGothic-Regular",
  "LeagueGothic-CondensedRegular",
  "Audiowide-Regular",
  "JosefinSans-Bold",
  "JosefinSans-BoldItalic",
  "JosefinSans-LightItalic",
  "JosefinSans",
  "JosefinSans-SemiBold",
  "JosefinSans-Thin",
  "Cookie-Regular",
  "IndieFlower",
  "Candal",
  "OpenSans-Bold",
  "OpenSans-BoldItalic",
  "OpenSans-Light",
  "OpenSans",
  "OpenSans-Italic",
  "Roboto-Regular",
  "Roboto-Black",
  "Roboto-Light",
  "Roboto-BoldItalic",
  "Roboto-LightItalic",
  "Roboto-Thin",
  "Roboto-MediumItalic",
  "Roboto-Medium",
  "Roboto-Bold",
  "Roboto-BlackItalic",
  "Roboto-ThinItalic",
  "Montserrat-Regular",
  "Montserrat-Bold",
  "Lora-Italic",
  "Lora-Regular",
  "Lora-BoldItalic",
  "Lora-Bold",
  "Lora-Italic",
  "Lora-Italic",
  "Lato-Regular",
  "Lato-Hairline",
  "Lato-HairlineItalic",
  "Lato-LightItalic",
  "Lato-Italic",
  "Lato-Bold",
  "Lato-BoldItalic",
  "Lato-Light",
  "PoiretOne-Regular"
];

export const fontKV: { key: string; value: string[] }[] = [
  { key: "Homestead", value: [] },
  {
    key: "Helvetica",
    value: ["Oblique", "BoldOblique", "Light", "Bold", "LightOblique"]
  },
  { key: "TimesNewRomanPSMT", value: [] },
  { key: "ArialMT", value: [] },
  {
    key: "Arial",
    value: ["BoldItalicMT", "BoldMT", "ItalicMT"]
  },
  { key: "Courier", value: ["Bold", "Oblique", "BoldOblique"] },
  {
    key: "CourierNewPS",
    value: ["BoldItalicMT", "BoldMT", "ItalicMT"]
  },
  { key: "CourierNewPSMT", value: [] },
  {
    key: "Futura",
    value: ["Medium", "CondensedExtraBold", "CondensedMedium", "MediumItalic"]
  },
  { key: "Papyrus", value: ["Condensed"] },
  { key: "GillSans", value: ["Bold", "Light", "Italic"] },
  { key: "Georgia", value: ["Bold", "BoldItalic", "Italic"] },
  { key: "Sullivan", value: ["Regular", "Bevel", "Fill"] },
  {
    key: "Lavanderia",
    value: ["Delicate", "Sturdy", "Regular"]
  },
  { key: "DemingEP", value: [] },
  {
    key: "OstrichSans",
    value: ["Light", "Medium", "Bold", "Black"]
  },
  {
    key: "HelveticaNeue",
    value: [
      "UltraLightItalic",
      "LightItalic",
      "CondensedBold",
      "CondensedBlack",
      "Bold",
      "Medium",
      "BoldItalic",
      "UltraLight",
      "Light",
      "Italic"
    ]
  },
  { key: "Museo", value: ["300", "500", "700"] },
  { key: "MuseoSans", value: ["300", "700"] },
  { key: "Lobster1.4", value: [] },
  {
    key: "LeagueGothic",
    value: ["Regular", "CondensedRegular"]
  },
  { key: "Audiowide", value: ["Regular"] },
  {
    key: "JosefinSans",
    value: ["Bold", "BoldItalic", "LightItalic", "SemiBold", "Thin"]
  },
  { key: "Cookie", value: ["Regular"] },
  { key: "IndieFlower", value: [] },
  { key: "Candal", value: [] },
  {
    key: "OpenSans",
    value: ["Bold", "BoldItalic", "Light", "Italic"]
  },
  {
    key: "Roboto",
    value: [
      "Regular",
      "Black",
      "Light",
      "BoldItalic",
      "LightItalic",
      "Thin",
      "MediumItalic",
      "Medium",
      "Bold",
      "BlackItalic",
      "ThinItalic"
    ]
  },
  { key: "Montserrat", value: ["Regular", "Bold"] },
  {
    key: "Lora",
    value: ["Italic", "Regular", "BoldItalic", "Bold", "Italic", "Italic"]
  },
  {
    key: "Lato",
    value: [
      "Regular",
      "Hairline",
      "HairlineItalic",
      "LightItalic",
      "Italic",
      "Bold",
      "BoldItalic",
      "Light"
    ]
  },
  { key: "PoiretOne", value: ["Regular"] }
];

export const typeFaceToStyle = () => {
  let map = new Map<string, string[]>();
  fontKV.forEach(({ key, value }) => {
    map.set(key, value);
  });
  return map;
};

export default typeFaceToStyle;
